import { useParams, Navigate } from "react-router-dom";
import { CircleDashed, Info } from "lucide-react";
import { ALL_NAV } from "@/lib/nav";
import { PageHeader, Badge } from "@/components/common/States";

export default function ModulePlaceholder() {
  const { key } = useParams();
  const item = ALL_NAV.find((i) => i.key === key && i.phase > 1);
  if (!item) return <Navigate to="/" replace />;
  const Icon = item.icon;
  return (
    <div data-testid={`module-placeholder-${key}`}>
      <PageHeader eyebrow={item.group} title={item.label} subtitle="This module is planned and not built yet." actions={<Badge tone="gold" data-testid="module-phase-badge">Coming in Phase {item.phase}</Badge>} />
      <div className="grid lg:grid-cols-[1.4fr_1fr] gap-6">
        <div className="g39-card p-6 sm:p-8 g39-rise">
          <div className="flex items-center gap-3 mb-6">
            <div className="h-11 w-11 rounded-lg bg-accent flex items-center justify-center"><Icon className="h-5 w-5 text-gold" /></div>
            <div>
              <div className="font-display font-semibold">Planned scope</div>
              <div className="text-xs text-muted-foreground">Delivered in Phase {item.phase} after review</div>
            </div>
          </div>
          <ul className="space-y-3">
            {item.features.map((f) => (
              <li key={f} className="flex items-start gap-3 text-sm">
                <CircleDashed className="h-4 w-4 text-gold mt-0.5 shrink-0" />{f}
              </li>
            ))}
          </ul>
        </div>
        <div className="g39-card g39-stripes p-6 g39-rise" style={{ animationDelay: "80ms" }} data-testid="module-not-built-notice">
          <Info className="h-5 w-5 text-gold mb-3" />
          <div className="font-display font-semibold">Not available yet</div>
          <p className="text-sm text-muted-foreground mt-2">Nothing on this page reads or saves data. Records for this module will only appear once it is built, tested and enabled for your company.</p>
        </div>
      </div>
    </div>
  );
}
